// app/javascript/controllers/candidates_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["functionalareaSelect", "positioncategorySelect", "tagSelect"]

    connect() {
        console.log("Candidates Controller connected"); // Debugging
        if (this.functionalareaSelectTarget.value) {
            this.loadDependentData()
        }
    }

    loadDependentData() {
        const functionalareaId = this.functionalareaSelectTarget.value
        if (!functionalareaId) return

        fetch(`/candidates/dependent_data?functionalarea_id=${functionalareaId}`)
            .then(response => {
                if (!response.ok) throw new Error("Network error");
                return response.json();
            })
            .then(data => {
                // KORREKTUR: Prüfe ob der Schlüssel 'positioncategories' oder 'positionscategories' ist!
                // Wahrscheinlich ist es 'positioncategories' (ohne s)
                const posData = data.positioncategories || data.positionscategories || [];
                const tagData = data.tags || [];

                this.fillSelect(this.positioncategorySelectTarget, posData, this.positioncategorySelectTarget.dataset.selected)
                this.fillSelect(this.tagSelectTarget, tagData, this.tagSelectTarget.dataset.selected)
            })
            .catch(error => console.error("Error loading dependent data:", error));
    }

    fillSelect(select, options, selectedId) {
        // Füge einen leeren Prompt hinzu (wie im Receipt Beispiel)
        select.innerHTML = '<option value="">Bitte wählen...</option>'

        options.forEach(opt => {
            const option = document.createElement("option")
            option.value = opt.id
            // KORREKTUR: Prüfe ob das Feld 'name', 'label' oder 'positioncategory' heißt
            option.textContent = opt.name || opt.label || opt.positioncategory || opt.description
            
            if (selectedId && selectedId.toString() === opt.id.toString()) {
                option.selected = true
            }

            select.appendChild(option)
        })
    }
}